import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CardStats from "components/Cards/CardStats.js";
import CardStats1 from "components/Cards/CardStats1.js";

export default function HeaderStatForExpDashboard() {
  const history = useHistory();
  const [currency, setCurrency] = useState("");
  const [count, setCount] = useState("");
  const [totalBalance, setTotalBalance] = useState([]);

  // Get userid from local storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  // Fetch all data in parallel
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [balanceResponse, currencyResponse, messageCountResponse] =
          await Promise.all([
            fetch(`${BASE_URL}/api/Expense/GetTotalBalance?groupId=${groupId}`),
            fetch(
              `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
            ),
            fetch(
              `${BASE_URL}/api/Expense/MessageCountByGroupID?GroupID=${groupId}`
            ),
          ]);

        const balanceData = await balanceResponse.json();
        const currencyData = await currencyResponse.json();
        const messageCountData = await messageCountResponse.json();

        setTotalBalance(balanceData);
        setCurrency(currencyData.currency);
        setCount(messageCountData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [groupId]);

  // Check if availableBalance is greater than 0
  const isPositiveBalance = totalBalance.availableBalance > 0;

  // Set the color dynamically based on the condition
  const balanceColor = isPositiveBalance ? "rgb(0, 0, 255)" : "red";

  return (
    <>
      {/* Header */}
      <div className="relative md:pt-8 pb-16 mt-4">
        <div className="mx-auto w-full">
          {/* Card stats */}
          <div className="flex flex-wrap">
            <div className="w-full sm:w-6/12 md:w-3/12 lg:w-3/12 px-4">
              <CardStats
                statSubtitle="Available Balance"
                statTitle={totalBalance.availableBalance}
                currency={currency}
                statPercentColor="text-emerald-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-red-500"
              />
            </div>
            <div className="w-full sm:w-6/12 md:w-3/12 lg:w-3/12 px-4">
              <CardStats
                statSubtitle="Total Credited"
                statTitle={totalBalance.totalCreatedSum}
                currency={currency}
                statPercentColor="text-orange-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-orange-500"
              />
            </div>
            <div className="w-full sm:w-6/12 md:w-3/12 lg:w-3/12 px-4">
              <CardStats
                statSubtitle="Total Debited"
                statTitle={totalBalance.totalDebitedSum}
                currency={currency}
                statPercentColor="text-red-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-pink-500"
              />
            </div>
            {/* <div className="w-full sm:w-6/12 md:w-3/12 lg:w-3/12 px-4">
              <CardStats1
                statSubtitle="Messages"
                statTitle={count.toString()}
                count={count}
                statPercentColor="text-fuchsia-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-teal-500"
              />
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
